var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/CollabPacket.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
var CollabPacketType = /* @__PURE__ */ ((CollabPacketType2) => {
  CollabPacketType2["Update"] = "update";
  CollabPacketType2["Awareness"] = "awareness";
  CollabPacketType2["QueryAwareness"] = "queryAwareness";
  CollabPacketType2["Populate"] = "populate";
  return CollabPacketType2;
})(CollabPacketType || {});
var CollabPacket = class extends AdornisEntity {
  static resolveID(e) {
    return Math.floor(Math.random() * 1e5).toString();
  }
  get payloadUint8Array() {
    try {
      return Uint8Array.from(atob(this.payload ?? ""), (c) => c.charCodeAt(0));
    } catch (e) {
      console.warn("Error decoding payload", this.payload);
    }
    throw new Error("Error decoding payload");
  }
};
CollabPacket._class = "CollabPacket";
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "targetClass", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "type", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "userID", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "username", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "cid", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "roomID", 2);
__decorateClass([
  Field((type) => String)
], CollabPacket.prototype, "payload", 2);
CollabPacket = __decorateClass([
  Entity()
], CollabPacket);
export {
  CollabPacket,
  CollabPacketType
};
